module.exports = __webpack_public_path__ + "static/media/Figtree-Bold.c35c3ee5.ttf";